
export class BadResponse extends Error {
  constructor({ message, field }, ...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BadResponse);
    }

    this.message = message;
    this.field = field;
  }
}

export class IgnoreError extends Error {
  constructor(params) {
    super(params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, IgnoreError);
    }
  }
}

export function getErrorMessage(error) {
  if (error) {
    const innerError = error.graphQLErrors[0] || error.networkError || error;
    return innerError.message;
  }

  return 'Unknown Error';
}



// WEBPACK FOOTER //
// ./src/utils/errors.js